// extracted by mini-css-extract-plugin
export default {"backLink":"pageBackLink_backLink__coji9","title":"pageBackLink_title__i9NMY"};